import PrevArrowIcon from 'assets/chevron-left';
import styled, { css } from 'styled-components';

/* When `centerContent` is provided the container switches to a 1fr auto 1fr grid so the
   middle slot sits truly page-centered with symmetric rails on either side; the default
   flex/space-between layout is preserved for the standard back-left + cart-right usage. */
export const NavigationHeaderContainer = styled.nav<{ $withCenter?: boolean }>`
  ${({ $withCenter }) =>
    $withCenter
      ? css`
          align-items: center;
          display: grid;
          grid-template-columns: 1fr auto 1fr;
        `
      : css`
          display: flex;
          justify-content: space-between;
        `}
  margin-bottom: 12px;
  min-height: 50px;
  width: 100%;
`;

export const LeftAligned = styled.div`
  display: flex;
`;

export const CenterAligned = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

export const RightAligned = styled.div`
  align-items: center;
  display: flex;
  gap: 35px;
  justify-content: flex-end;
`;

export const HoverablePrevArrowIcon = styled(PrevArrowIcon)<{ isRTL: boolean }>`
  transition: color 0.3s ease;
  color: var(--way-colors-contrastColorShades-70);

  transform: ${({ isRTL }) => (isRTL ? 'rotate(180deg)' : 'none')};

  &:hover {
    color: var(--way-colors-contrastColorShades-100);
  }
`;

export const LinksBack = styled.button`
  background-color: inherit;
  border-style: none;
  align-items: center;
  display: flex;
  font-size: 14px;
`;

export const IconBack = styled.div`
  height: 20px;
  width: 18px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;

export const BackLabel = styled.span`
  /* skip css namespace */
  cursor: pointer;
  display: inline-block;
  font-weight: 350;
  font-size: 16px;
  line-height: 40px;
  white-space: nowrap;
  text-transform: capitalize;
  transition: color 0.3s ease;
  color: var(--way-colors-contrastColorShades-70);

  &:hover {
    color: var(--way-colors-contrastColorShades-100);
  }
`;
